import { combineReducers } from 'redux';

import { userReducer as user } from './userReducer'

export default combineReducers({
    user
})